import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { AdminPage, Card, CardMeta, CardTitle } from '@/design/components';
import { useMe } from '@/auth/useMe';
import { useModules } from '@/access/useModule';
import { LISTS } from './registry';

/**
 * מפתח ההגדרות. מוצגות רק רשימות של מודולים פעילים
 * ושיש לעובד הרשאה אליהן.
 */
export function SettingsIndexPage() {
  const { me } = useMe();
  const modules = useModules();

  const visible = LISTS.filter((list) => {
    if (list.hideFromSettings) return false;
    if (list.module && modules[list.module] !== true) return false;
    return me?.permissions.includes(list.perm) ?? false;
  });

  return (
    <AdminPage title="הגדרות" subtitle="כל רשימה במערכת נערכת כאן, בלי שינוי קוד">
      {visible.length === 0 && <CardMeta>אין לך הרשאה לאף רשימה. פנה/י למנהל/ת המערכת.</CardMeta>}

      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
        {/* מסך ייעודי: השורה היא הצטלבות של רצועה ויום, ולכן הרשימה
            הגנרית לא מתאימה לה */}
        {modules.schedule === true && me?.permissions.includes('schedule.settings') && (
          <Link to="/admin/settings/requirements" className="no-underline">
            <Card className="flex h-full flex-row items-center justify-between gap-3">
              <span className="grid gap-1">
                <CardTitle className="text-title">דרישות כוח אדם</CardTitle>
                <CardMeta>כמה אנשים צריך בכל רצועה ובכל יום.</CardMeta>
              </span>
              <ChevronLeft size={24} strokeWidth={1.75} aria-hidden="true" className="shrink-0" />
            </Card>
          </Link>
        )}

        {visible.map((list) => (
          <Link key={list.key} to={`/admin/settings/${list.key}`} className="no-underline">
            <Card className="flex h-full flex-row items-center justify-between gap-3">
              <span className="grid gap-1">
                <CardTitle className="text-title">{list.label}</CardTitle>
                <CardMeta>{list.description}</CardMeta>
              </span>
              <ChevronLeft size={24} strokeWidth={1.75} aria-hidden="true" className="shrink-0" />
            </Card>
          </Link>
        ))}
      </div>
    </AdminPage>
  );
}
